module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-toyota.5e6609f4.jpg";